import { AfterContentInit, ChangeDetectorRef, Component, inject, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatOption, MatSelect, MatSuffix } from '@angular/material/select';
import { DefaultSavedTableSettings, SavedTableSettings, SessionStorageService } from '@core';

@Component({
  imports: [MatIcon, MatSelect, MatOption, MatFormField, MatSuffix],
  selector: 'app-table-zoom',
  standalone: true,
  styleUrl: './table-zoom.component.scss',
  templateUrl: './table-zoom.component.html',
})
export class TableZoomComponent implements AfterContentInit {
  tableId = input<string | null>(null);

  zoomChanged = output<string | null>();

  protected tableSavedData: SavedTableSettings = DefaultSavedTableSettings;
  protected zoomValues: number[] = [75, 100, 125, 150, 175];
  protected currentValue: number = 100;
  protected currentStep: number = this.zoomValues.indexOf(this.currentValue);
  protected countOfSteps = this.zoomValues.length - 1;
  private cdr = inject(ChangeDetectorRef);
  private sessionStorageService = inject(SessionStorageService);

  ngAfterContentInit(): void {
    this.setSavedZoomAsDefault();
  }

  protected setSavedZoomAsDefault() {
    if (!this.tableId()) return;
    this.tableSavedData = this.sessionStorageService.getItem(this.tableId()!) as SavedTableSettings;
    if (this.tableSavedData?.zoomSize) {
      this.currentValue = this.tableSavedData.zoomSize;
      this.currentStep = this.zoomValues.indexOf(this.currentValue);
      this.cdr.detectChanges();

      this.zoomChanged.emit(`${this.currentValue}%`);
    }
  }

  protected changeZoomValue(value: string, particularValue: boolean = false) {
    if (particularValue) {
      this.currentValue = parseInt(value, 10);
      this.currentStep = this.zoomValues.indexOf(this.currentValue);
    } else {
      this.currentStep += parseInt(value, 10);
      this.currentValue = this.zoomValues[this.currentStep];
    }
    this.zoomChanged.emit(`${this.currentValue}%`);
    this.cdr.detectChanges();
    if (!this.tableId()) return;
    this.tableSavedData = this.sessionStorageService.getItem(this.tableId()!) || DefaultSavedTableSettings;
    this.tableSavedData.zoomSize = this.currentValue;
    this.sessionStorageService.setItem(this.tableId()!, this.tableSavedData);
  }
}
